/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { Fragment, type PropsWithChildren } from 'react';

import { jsx } from '@compiled/react';

import { Box } from '@atlaskit/primitives/compiled';

import { WidthObserverElement } from '../../../common/ui/width-observer';
import { Body } from './body';
import Header from './header';
import HeaderSideBySide from './header-side-by-side';

type Components = {
	autoCorrection?: JSX.Element;
	feedback?: JSX.Element;
	filters: JSX.Element;
	input?: JSX.Element;
	oauthContainer?: JSX.Element;
	results?: JSX.Element;
	rightPanel?: JSX.Element;
	smartAnswers?: JSX.Element;
};

type LayoutProps = {
	components: Components;
	disableHeaderGridStyles?: boolean;
};

export const Layout = ({
	components: {
		filters,
		results = <Fragment></Fragment>,
		input = <Fragment></Fragment>,
		feedback = <Fragment></Fragment>,
		smartAnswers = <Fragment></Fragment>,
		oauthContainer = <Fragment></Fragment>,
		rightPanel = <Fragment></Fragment>,
		autoCorrection = <Fragment></Fragment>,
	},
	disableHeaderGridStyles,
}: PropsWithChildren<LayoutProps>): JSX.Element => (
	<WidthObserverElement id="layout">
		<Box testId="search-page-layout">
			<Header
				components={{ input, feedback, filters }}
				disableHeaderGridStyles={disableHeaderGridStyles}
			/>
			<Body components={{ results, smartAnswers, rightPanel, oauthContainer, autoCorrection }} />
		</Box>
	</WidthObserverElement>
);

type LayoutSideBySideProps = {
	components: {
		autoCorrection: JSX.Element;
		filters: JSX.Element;
		oauthContainer: JSX.Element;
		results: JSX.Element;
		smartAnswers: JSX.Element;
	};
};

export const LayoutSideBySide = ({
	components: { filters, results, smartAnswers, oauthContainer, autoCorrection },
}: PropsWithChildren<LayoutSideBySideProps>): JSX.Element => (
	<Box testId="search-page-layout">
		<HeaderSideBySide components={{ filters }} />
		<Body components={{ results, smartAnswers, oauthContainer, autoCorrection }} />
	</Box>
);
